import React from 'react';

import Spinner from '@atlaskit/spinner/spinner';

import { SearchLoadWrapper } from '../LiveSearchElementStructure.tsx';

export const SearchLoading = (): React.JSX.Element => (
	<SearchLoadWrapper>
		<Spinner size="small" />
	</SearchLoadWrapper>
);
